module.exports = __webpack_public_path__ + "d308073b/img/arrow-share-icon.00a12c29.svg";